import React, { useEffect, useState } from "react";
import moment from 'moment';
import { GetData } from "../Api/index.js";
import CustomBarChart from "../Components/BarChart/custom-bar-chart.component.js";
import CustomRadialChart from "../Components/RadialChart/custom-radial-chart.component.js";
import { useRef } from "react";
import PnPUtilService from "../utils/pnp-util.service.js";
import WidgetLoader from "../Components/loaders/widget-loader.component.js";
import {isEmpty, map} from 'lodash';
import { useTranslation } from "react-i18next";
moment.suppressDeprecationWarnings = true;


const PnpMachineDowntime = (props) => {
  const { t } = useTranslation();
  let shift = props.shift;
  const defaultDownTimeData = [
    { "name": "Error Stop", "data": [0] },
    { "name": "Maintenance", "data": [0] }
  ];
  const defaultStatusForDowntime = map(defaultDownTimeData, 'name');
  let barChartYAxisData = useRef(defaultDownTimeData);
  let barChartXAxisLabels = useRef(defaultStatusForDowntime);
  let oeePie = useRef(0);
  let availability = useRef(0);
  let performance = useRef(0);
  let quality = useRef(0);
  let dataRefreshTimer = useRef(null);
  let [loading, setLoading] = useState(true);
  const resetDonutsData = () => {
    oeePie.current = 0;
    availability.current = 0;
    performance.current = 0;
    quality.current = 0;
  };
  const resetBarsData = () => {
    barChartYAxisData.current = defaultDownTimeData;
    barChartXAxisLabels.current = defaultStatusForDowntime;
  }
  const resetChartData = () => {
    resetBarsData();
    resetDonutsData();
  };
  const refreshData = (start, end) => {
    destroyDataRefresh()
    resetChartData();
    getMetrics(start, end);
    dataRefreshTimer.current = setTimeout(()=>{
      let diff = 0;
      if(props.rangeSelected){
        diff = 3*60*1000; // XXX -> 3 mins x 60 seconds x 1000 milliseconds
      }
      refreshData((props.from+diff), (props.to+diff));
    }, PnPUtilService.PNP_MACHINE_STATUS_REFRESH);
  };
  const getMetrics = (start, end) => {
    setLoading(true);
    const startOfDay = moment(start ?? props.from).unix();
    const endOfDay = moment(end ?? props.to).unix();
    Promise.all([
      GetData( `dashboard/pick-place?PNP=DOWNTIME&factoryId=${props.factory.factoryId}&startTs=${startOfDay}&endTs=${endOfDay}&machineId=${props.selectedMachineName}&reportType=downtime_measures&shift=${shift.id}` ),
      GetData( `dashboard/pick-place?PNP=DOWNTIME&factoryId=${props.factory.factoryId}&startTs=${startOfDay}&endTs=${endOfDay}&machineId=${props.selectedMachineName}&reportType=downtime&shift=${shift.id}` )
    ]).then((responses)=>{
      getPnpMetrics(responses[0]);
      getDownTime(responses[1]);
    }).finally(()=>{
      setLoading(false);
    });
  };
  const destroyDataRefresh = ()=>{
    if(dataRefreshTimer.current){
      clearTimeout(dataRefreshTimer.current);
    }
  };
  const getPnpMetrics = (response) => {
    let data = response?.data??{oee:0,availability:0,performance:0,quality:0};
    oeePie.current = isNaN(data.oee) ? 0 : parseFloat(data.oee.toFixed(1));
    availability.current = isNaN(data.availability) ? 0 : parseFloat(data.availability.toFixed(1));
    performance.current = isNaN(data.performance) ? 0 : parseFloat(data.performance.toFixed(1));
    quality.current = isNaN(data.quality) ? 0 : parseFloat(data.quality.toFixed(1));
  };
  const getDownTime = (response) => {
    if(!isEmpty(response?.data)){
      getDowntimeValues(response?.data);
    }
  };
  const getDowntimeValues = (data) => {
    let downtimeData = [
      { "name": "Downtime", "data": [data["Error Stop"], data["Maintenance"]] }
    ];
    barChartYAxisData.current = downtimeData;
    barChartXAxisLabels.current = [t("LT_error_stop"), t("LT_maintenance")];
  };
  const getDonutColor = (data) => {
    return (data < 55) ? ["#ff5544"] : ( ( data < 80 ) ? ["#ffc60a"] : ["#3cc480"]);
  };
  useEffect(()=>{
    if(!isEmpty(props.factory) 
    && !isEmpty(props.selectedMachineName) 
    && !isEmpty(props.shift) 
    && !isNaN(props.from) 
    && !isNaN(props.to)){
      refreshData();
    }
    return ()=>{
      destroyDataRefresh();
    };
  }, [props]);
  
  return (
    <div className="cv-pnp-dashboard">
      <div className="px-4 pt-2">
        <div className="d-flex justify-content-between">
          <div className="text-start inspection-dashboard-title">
            {props.selectedMachineName} - {t("LT_machine_oee")}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="cv-pnp-downtime w-100">
          {loading ? 
            <div className="cv-downtime-loader d-flex justify-content-center align-items-center">
            <WidgetLoader /> 
            </div>: 
              <CustomBarChart series={barChartYAxisData.current} labels={barChartXAxisLabels.current} xAxisDisabled={false} 
                labelSuffix="" width="100%" height={250} title={t("LT_downtime")} yAxisTitle={t("LT_number_of_seconds")}/>}
          </div>
          <div className="cv-pnp-metrics">
            <div className="d-flex align-items-center">
              <div>
                <CustomRadialChart series={[oeePie.current]} title ={t("LT_oee")} 
                  labels = {["OEE"]} innerText={oeePie.current} width={200} 
                  colors={ getDonutColor(oeePie.current)}/>
              </div>
              <div>
                <ul className="list-unstyled width100">
                  <li><span className="bgcolor9 cv-legend">&nbsp;&nbsp;</span>&nbsp;<span>{t("LT_high")}</span></li>
                  <li><span className="bgcolor8 cv-legend">&nbsp;&nbsp;</span>&nbsp;<span>{t("LT_medium")}</span></li>
                  <li><span className="bgcolor7 cv-legend">&nbsp;&nbsp;</span>&nbsp;<span>{t("LT_low")}</span></li>
                </ul>
              </div>
            </div>
            <div className="row p-0" style={{position:'relative', top: '-60px'}}>
              <div className="col-3 p-0">
                <CustomRadialChart series={[availability.current]} title ={t("LT_avail")} 
                  labels ={["Avail"]} innerText={availability.current} 
                  width={150} colors={getDonutColor(availability.current)}/>
              </div>
              <div className="col-3 p-0">
                  <CustomRadialChart series={[performance.current]} title ={t("LT_perf")} 
                    labels ={["Perf"]} innerText={performance.current} 
                    width={150} colors={ getDonutColor(performance.current)}/>
              </div>
              <div className="col-3 p-0">
                <CustomRadialChart series={[quality.current]} title ={t("LT_qual")} 
                  labels ={["Qual"]} innerText={quality.current} 
                  width={150} colors={ getDonutColor(quality.current)}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PnpMachineDowntime;
